import React from 'react';
import Icon from '../../@shared/icon';

const MenuTriggerContentWithIcon = ({ iconField, textValue }) => {
  return (
    <span className="navigation__menu-item__trigger__content navigation__menu-item__trigger__content--with-icon">
      <Icon iconField={iconField} extraClassName="navigation__menu-item__trigger__icon" size={24} />
      <span className="navigation__menu-item__trigger__text">{textValue}</span>
    </span>
  );
};

export default MenuTriggerContentWithIcon;
